import React from 'react';
import { Button } from 'primereact/button';
import actionsIcon from '../../../../assets/images/actions_purple.svg';

const CredentialsActionUploadButton = ({ credentialType, onClickCallback }) => {
	const unallowedTypes = ['FACILITY_APPROVED_WORKER', 'PROVISIONED_WORKER'];
	const isAllowed = !unallowedTypes.includes(credentialType);

	return isAllowed ? (
		<Button
			type="button"
			className="btn actions"
			key={credentialType}
			onClick={onClickCallback}
			aria-controls="popup_menu_left"
			aria-haspopup
		>
			<img src={actionsIcon} alt="upload" />
		</Button>
	) : (
		<></>
	);
};

export default CredentialsActionUploadButton;
